import { connect } from "react-redux";
import Graph from "../components/Graph";
import { getCurrentData, getKpiSelected } from "../selectors";
import { fetchStats } from "../actions/stats";

const mapStateToProps = (state, ownProps) => {
	const stats = state.stats || {};

	return {
		graphLoading: state.stats.graphLoading,
		data: getCurrentData(state),
		period: stats.period,
		kpi: getKpiSelected(state),
	};
};

export default connect(
	mapStateToProps,
	{fetchStats},
)(Graph);



// WEBPACK FOOTER //
// src/modules/stats/containers/GraphContainer.js